import React, { useEffect } from 'react';
import { Icon, Toast, Upload } from '@roo/roo';
import PropType from 'prop-types';
import { get, isEqual } from 'lodash';
import { useUpdateEffect } from 'ahooks';
import axx from 'axios';
import styled from 'styled-components';
import { useDeepDeps } from '../../pages/apply/_utils/hooks';
import up_file from '../../assets/images/apply/up_file.png';
import { getFileDownloadUrl, getS3Token } from '../../assets/apis/base';
import { getLocalUserData } from '../UserData/user';

import { FilesView } from '../../pages/applyView/_components/FilesView';
import { genStr } from '../../utils/utils';

const Root = styled.div`
  .upload {
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 2px;
    height: 94px;
    text-align: center;
    font-size: 14px;
    color: #666666;
    padding-top: 20px;

    > p {
      margin-top: 8px;

      &:last-child {
        font-size: 12px;
        color: #999999;
      }
    }
  }
`;

const axios = axx.create({ withCredentials: false });

export const FILETYPES = {
  img: {
    size: 1024 * 1024 * 10, // 文件大小
    accept: '.png,.jpg', // 文件类型
  },
  pdf: {
    size: 1024 * 1024 * 10,
    accept: '.pdf',
  },
  docx: {
    size: 1024 * 1024 * 10,
    accept: '.doc,.docx,.pdf',
  },
  doc: {
    size: 1024 * 1024 * 1024,
    accept: '.pdf',
  },
  imgpdf: {
    size: 1024 * 1024 * 10,
    accept: '.png,.jpg,.pdf',
  },
  all: {
    size: 1024 * 1024 * 1024,
    accept: '.png,.jpg,.pdf,.doc,.docx',
  },
};
export const file_name_separator = '({&!$!&})';

export const UploadField = function (props) {
  const [token, setToken] = React.useState({});
  const [fileList, setFileList] = React.useState(getFileList(props.value));
  const { type, maxFiles = 1 } = props;
  const { accept, size } = FILETYPES[type];
  const s3url = `https://mss.sankuai.com/${token.bucketName}`;
  const isList = Array.isArray(props.value);

  useEffect(() => {
    getS3Token().then((res) => {
      setToken(res);
    });
  }, []);

  function getFileUrls(files) {
    const urls = files.map((f) => get(f, 'key')).filter(Boolean);
    return isList ? urls : urls[0];
  }

  useUpdateEffect(
    () => {
      if (!isEqual(props.value, getFileUrls(fileList))) {
        setFileList(getFileList(props.value));
      }
    },
    [useDeepDeps(props.value)],
  );

  function handleUpload(file) {
    const { policy, signature, awsaccessKeyId } = token;
    const params = {
      policy, key: file.key, signature, awsaccessKeyId,
    };
    const formData = new FormData();

    Object.entries(params).forEach(([k, v]) => {
      formData.append(k, v);
    });
    formData.append('file', file);
    axios.post(s3url, formData).then((res) => {
      if (res.status === 200) {
        const newFiles = [...fileList, file];
        setFileList(newFiles);
        if (props.onChange) {
          props.onChange(getFileUrls(newFiles));
        }
      } else {
        Toast.fail({ title: '上传失败' });
      }
    });
  }

  const children = props.children || (
    <div className="upload">
      {/*<Icon name='upload' />*/}
      <img src={up_file} alt="" />
      <p>请点击或拖拽文件至此上传</p>
      <p>
        请上传
        {accept.replace(/\,/g, '/')}
        格式的文件,大小不超过10M
      </p>
    </div>
  );
  if (props.disabled) {
    return <FilesView value={fileList.map((f) => f.key).filter(Boolean)} />;
  }

  return (
    <Root className={fileList.length < maxFiles ? 'file-input' : 'file-full'}>
      <Upload
        canDrop
        showUploadList
        style={props.style}
        disabled={props.disabled}
        showType="list"
        withCredentials={false}
        fileList={fileList.map((f) => {
          let name = f.name;
          try {
            const ns = f.name.split(file_name_separator).filter(Boolean).pop();
            name = ns || name;
          } catch (e) {
            // nox
          }
          return { ...f, name };
        })}
        className="dropClass"
        validityCallback={(files) => {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.size > props.maxSize) {
              Toast.fail({
                title: '文件大小超过限制',
              });
              return false;
            }
            if (file.name.includes('@')) {
              Toast.fail({
                title: '标题包含特殊符号，上传失败',
              });
              return false;
            }
            // 拼接文件路径，使用分隔符将文件路径和名称进行分割
            const k = `${token.dir}${genStr()}${file_name_separator}${file.name}`.replace(/\s/g, '');
            file.key = k;
            handleUpload(file);
          }
          return false;
        }}
        accept={accept}
        size={size}
        action={s3url}
        onRemove={(file, FileList) => {
          if (props.onChange) {
            props.onChange(getFileUrls(FileList));
          }
        }}
        onPreview={(f) => {
          if (props.canPreview) {
            const { mtUid } = getLocalUserData();
            getFileDownloadUrl({ fileName: f.key || f, userId: mtUid, needWatermark: false }).then((res) => {
              if (res) {
                downloadUrl(res);
              }
            });
          }
        }}
      >
        {fileList.length < maxFiles ? children : null}
      </Upload>
    </Root>
  );
};

function downloadUrl(href) {
  // 创建隐藏的可下载链接
  const eleLink = document.createElement('a');
  eleLink.style.display = 'none';
  eleLink.href = href;
  eleLink.target = '_blank';
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
}

function getFileList(fileUrls = []) {
  if (typeof fileUrls === 'string') {
    fileUrls = [fileUrls];
  }

  const t = Date.now().valueOf();
  return fileUrls.filter(Boolean).map((url, idx) => {
    const xs = url.split('/');
    return {
      name: xs.pop(),
      uid: String(t + idx),
      url,
      status: 'success',
      key: url,
    };
  });
}

UploadField.propTypes = {
  maxFiles: PropType.number,
  // 单位是b
  maxSize: PropType.number,
  disabled: PropType.bool,
  value: PropType.arrayOf(PropType.string),
  handleChange: PropType.func,
  onChange: PropType.func,
  accept: PropType.arrayOf(PropType.string),
  style: PropType.object,
  type: PropType.string,
  canPreview: PropType.bool,
};

UploadField.defaultProps = {
  files: [],
  maxSize: 10 * 1024 * 1024,
  maxFiles: 1,
  accept: [],
  type: 'img',
};

export default UploadField;
